import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPackage } = FiIcons;

const brands = ['Apple', 'Samsung', 'Google', 'OnePlus', 'Motorola', 'LG', 'Other'];
const conditions = [
  { value: 'excellent', label: 'Excellent', desc: 'Like new, no scratches or damage' },
  { value: 'good', label: 'Good', desc: 'Minor wear, fully functional' },
  { value: 'fair', label: 'Fair', desc: 'Visible scratches, works fine' },
  { value: 'poor', label: 'Poor', desc: 'Cracked screen or major damage' },
];

export default function Step2bTradeIn({ onSubmit }) {
  const [brand, setBrand] = useState('');
  const [model, setModel] = useState('');
  const [storage, setStorage] = useState('');
  const [condition, setCondition] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (brand && model && condition) onSubmit({ brand, model, storage, condition });
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="card-premium">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-indigo-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <SafeIcon icon={FiPackage} className="w-7 h-7 text-indigo-600" />
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-2">Tell Us About Your Device</h2>
        <p className="text-slate-600">We'll calculate a trade-in value to offset your carrier balance.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Phone Brand</label>
          <div className="flex flex-wrap gap-2">
            {brands.map(b => (
              <button key={b} type="button" onClick={() => setBrand(b)}
                className={`px-4 py-2 rounded-lg border-2 text-sm font-medium transition-all
                  ${brand === b ? 'border-indigo-600 bg-indigo-50 text-indigo-700' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`}>
                {b}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Model Name / Number</label>
          <input type="text" required placeholder="e.g. iPhone 14 Pro, Galaxy S23"
            value={model} onChange={e => setModel(e.target.value)}
            className="block w-full rounded-lg border-slate-300 border py-3 px-4 text-slate-900 focus:ring-indigo-500 focus:border-indigo-500 outline-none" />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Storage Capacity (optional)</label>
          <select value={storage} onChange={e => setStorage(e.target.value)}
            className="block w-full rounded-lg border-slate-300 border py-3 px-4 text-slate-900 outline-none">
            <option value="">Select storage...</option>
            {['64GB', '128GB', '256GB', '512GB', '1TB'].map(s => <option key={s}>{s}</option>)}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Device Condition</label>
          <div className="grid grid-cols-2 gap-3">
            {conditions.map(c => (
              <button key={c.value} type="button" onClick={() => setCondition(c.value)}
                className={`p-4 rounded-xl border-2 text-left transition-all
                  ${condition === c.value ? 'border-indigo-600 bg-indigo-50' : 'border-slate-200 hover:border-slate-300'}`}>
                <div className={`font-semibold text-sm ${condition === c.value ? 'text-indigo-700' : 'text-slate-800'}`}>{c.label}</div>
                <div className="text-xs text-slate-500 mt-0.5">{c.desc}</div>
              </button>
            ))}
          </div>
        </div>

        <button type="submit" disabled={!brand || !model || !condition}
          className="w-full btn-primary py-4 text-lg disabled:opacity-40 disabled:cursor-not-allowed">
          Get My Trade-In Estimate
        </button>
      </form>
    </motion.div>
  );
}